<template>
    <div :class="['progress-bar-tooltip-container', customClass]">
        <CompassTooltip
            :content="tooltipContent"
            :contentClass="tooltipContentClass"
            :placement="tooltipPlacement"
            :arrow="tooltipArrow"
            :disabled="tooltipDisabled"
            :theme="tooltipTheme"
            :delay="tooltipDelay"
        >
            <CompassProgressBar
                :state="progressBarState"
                :caption="progressBarCaption"
                :type="progressBarType"
            />
        </CompassTooltip>
    </div>
</template>

<script>
export default {
    props: {
        progressBarState: {
            type: Number,
            required: true,
        },
        progressBarCaption: {
            type: String,
            default: '',
        },
        progressBarType: {
            type: String,
            default: 'default',
        },
        tooltipContent: {
            type: String,
            default: null,
        },
        tooltipContentClass: {
            type: String,
            default: '',
        },
        tooltipPlacement: {
            type: String,
            default: 'bottom',
        },
        tooltipArrow: {
            type: Boolean,
            default: true,
        },
        tooltipDisabled: {
            type: Boolean,
            default: false,
        },
        tooltipTheme: {
            type: String,
            default: 'dark',
        },
        tooltipDelay: {
            type: Object,
            default: () => {
                return { show: 0, hide: 0 };
            },
        },
        customClass: {
            type: String,
            default: '',
        },
    },
};
</script>
